import * as Sentry from '@sentry/react';

import { get as getUser } from 'js/lib/user';

import {
  type EDUCATION_LEVEL_OPTIONS_TYPE,
  type LEARNING_GOAL_OPTIONS_TYPE,
} from 'bundles/onboarding-common/constants';
import type { SelectedRole, Skill } from 'bundles/onboarding-common/types';
import { updateUserProfile as updateUserProfileAPI } from 'bundles/onboarding-common/utils/userProfileApi';
import { formatDemographics } from 'bundles/onboarding-common/utils/userProfileUtils';

export type UserProfileDataType = {
  learningGoal?: LEARNING_GOAL_OPTIONS_TYPE;
  educationLevel?: EDUCATION_LEVEL_OPTIONS_TYPE;
  currentOccupation?: Record<string, string>;
  skillsWanted?: Array<Skill>;
  isUnsureOfSkills?: boolean;
  occupationPreferences?: Array<SelectedRole>;
  isUnsureOfRoles?: boolean;
};

const useUpdateUserProfile = () => {
  const updateUserProfile = async ({
    learningGoal,
    educationLevel,
    currentOccupation,
    skillsWanted,
    isUnsureOfSkills,
    occupationPreferences,
    isUnsureOfRoles,
    userId,
    externalId,
  }: UserProfileDataType & {
    userId?: number;
    externalId?: string;
  }) => {
    const data = {
      userId: userId || getUser().id,
      externalId: externalId || getUser().external_id,
      demographics: formatDemographics({
        learningGoal,
        educationLevel,
        currentOccupation,
        skillsWanted,
        occupationPreferences,
        isUnsureOfSkills,
        isUnsureOfRoles,
      }),
    };

    try {
      await updateUserProfileAPI(data);

      return Promise.resolve();
    } catch (error) {
      Sentry.captureException('Error updating user profile:', error);

      return Promise.reject(error);
    }
  };

  return { updateUserProfile };
};

export default useUpdateUserProfile;
